// extracted by mini-css-extract-plugin
export var card = "ContentfulComponentRelatedArticles-module--card--51d8a";
export var cardWrapper = "ContentfulComponentRelatedArticles-module--cardWrapper--81552";
export var carouselPagination = "ContentfulComponentRelatedArticles-module--carouselPagination--3cd93";
export var carouselSlider = "ContentfulComponentRelatedArticles-module--carouselSlider--bbfe0";
export var category = "ContentfulComponentRelatedArticles-module--category--fe744";
export var heading = "ContentfulComponentRelatedArticles-module--heading--68349";
export var image = "ContentfulComponentRelatedArticles-module--image--e4c7a";
export var intro = "ContentfulComponentRelatedArticles-module--intro--8ff3a";
export var pageIndicator = "ContentfulComponentRelatedArticles-module--pageIndicator--eb3ec";
export var section = "ContentfulComponentRelatedArticles-module--section--994a3";
export var title = "ContentfulComponentRelatedArticles-module--title--12b09";